module.exports = __webpack_public_path__ + "static/logo-d6cd5dd29ef2cf9d2992f833e032c4a6.png";